import Enum from 'enum';

export default new Enum(['unpaid', 'paid']);



// WEBPACK FOOTER //
// ./src/utils/orderState.js